module.exports = __webpack_public_path__ + "static/media/NikeN7-Potential.6a583286.jpg";